import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';

import {Subscription} from 'rxjs/Subscription';
import {MatDialogRef} from '@angular/material';

import { AuthGuardService, CommercialService, UserService } from '@core/services';
import { User } from '@shared/models';

@Component({
  selector: 'app-add-toll-pass-dialog',
  templateUrl: './add-toll-pass-dialog.component.html',
  styleUrls: ['./add-toll-pass-dialog.component.css']
})
export class AddTollPassDialogComponent implements OnInit {

  addTollPass: FormGroup;
  private user: User;
  private subscription: Subscription;
  private commercial: any;
  private commercialSubscription: Subscription;

  constructor(public dialogRef: MatDialogRef<AddTollPassDialogComponent>,
              private _fb: FormBuilder,
              private _authGuard: AuthGuardService,
              private _userService: UserService, private _commercialService: CommercialService) {
  }

  ngOnInit() {
    this.subscription = this._userService.getUser().subscribe(user => this.user = user);
    this.commercialSubscription = this._commercialService.getCommercialValue().subscribe(commercial => this.commercial = commercial);
    this.addTollPass = this._fb.group({
      addTollPassGroup: this._fb.group({
        PassName: new FormControl(),
        PassTypeId: new FormControl(),
        NumberOfPasses: new FormControl(),
        VehicleClass: new FormControl(),
        AxelCount: new FormControl()
      })
    });
  }

  onSubmit() {
    this.submitAccountCards(this.setUpAccountCards())
  }

  private submitAccountCards(_accountCardInfo: { formData: { AccountId: any; CardList: any }; url: string }) {
    this._authGuard.authenticatedPost(_accountCardInfo.url, _accountCardInfo.formData).subscribe(
      result => {
        console.log('Successful insertAccountCardsFree', result);
        this.dialogRef.close(true);
      },
      error => console.log('Error: ' + error)
    );
  }

  private setUpAccountCards() {
    let formData = { 'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id,
                     'CardList': [this.addTollPass.value.addTollPassGroup]};
    let url= 'portfolios/insertaccountcardsfree';
    if(this.commercial){
      if(this.commercial.isCustomerCommercial){
        url= 'portfolios/insertaccountcardscommercial';
        formData = {
          'AccountId': this.user.customerIdArray[this.user.customerIndex].Id,
          'CardList' : [this.addTollPass.value.addTollPassGroup]
        };
      } else {
        formData = {
          'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id,
          'CardList': [this.addTollPass.value.addTollPassGroup]
        }
      }

    }
    return {formData, url};
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/add-toll-pass-dialog/add-toll-pass-dialog.component.ts